<template>
  <modal
    title="Détails de l'intervention"
    @close="cancel()">

    <div class="ronde-details">
      <div v-if="message !== null"
           v-bind:class="'callout callout-'+message.type">
        <p>{{message.text}}</p>
      </div>
      <div v-if="mode === 'show'">
        <div class="row">
          <div class="col-sm-1">
            <div class="index-item">
              <span class="title-item">N°</span>
              <span class="text-item text-item--sm">{{intervention.order + 1 }}</span>
            </div>
          </div>
          <div class="col-sm-5 left-separator right-separator">
            <div class="item-group">
              <span class="title-item">Adresse</span>
              <span
                class="text-item text-item--sm">{{intervention.adresse.numero}} {{intervention.adresse.voie}} {{intervention.adresse.ville}}</span>
            </div>
            <div class="item-group" v-if="intervention.adresse.presentationVille && intervention.adresse.presentationNumero && intervention.adresse.presentationVoie">
              <span class="title-item">Adresse de présentation</span>
              <span
                class="text-item text-item--sm">{{intervention.adresse.presentationNumero}} {{intervention.adresse.presentationVoie}} {{intervention.adresse.presentationVille}}</span>
            </div>
            <div class="item-group" v-if="intervention.adresse.heureOuverturePortes">
              <span class="title-item">Heure d'ouverture des portes</span>
              <span
                class="text-item text-item--sm">{{intervention.adresse.heureOuverturePortes}}</span>
            </div>
            <div class="item-group" v-if="intervention.adresse.presenceMarches || intervention.adresse.plusTroisPortes || intervention.adresse.pentu || intervention.adresse.grandeDistance ">
              <span class="title-item">Points noirs</span>
              <span class="text-item text-item--sm">
              <ul>
                <li v-if="intervention.adresse.presenceMarches">Présence de marches</li>
                <li v-if="intervention.adresse.plusTroisPortes">Plus de 3 portes</li>
                <li v-if="intervention.adresse.pentu">Pente à 30%</li>
                <li v-if="intervention.adresse.grandeDistance">Plus de 50m</li>
              </ul>
            </span>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="item-group">
              <span class="title-item">Bacs</span>
              <span class="text-item text-item--sm">
              <img src="/static/img/poubelle-grise.svg"/> {{intervention.adresse.bacsOm}} OM<br/>
              <img src="/static/img/poubelle-jaune.svg"/> {{intervention.adresse.bacsCs}} CS
            </span>
            </div>
            <div class="item-group">
              <span class="title-item">Commentaire</span>
              <span class="text-item" v-html="intervention.adresse.commentaire ?
              intervention.adresse.commentaire.replace(/\n/g, '<br />') : '-'">
            </span>
            </div>
          </div>
          <div class="col-sm-3 left-separator">
            <div class="item-group">
              <span class="title-item">Status</span>
              <span class="text-item text-item--sm">
              <div class="sortie_rentree_hours"
                   :class="(intervention.sortieBacs)?'sortie':'rentree'">
                <div class="icon">
                  <img src="/static/img/sortie.svg" v-if="intervention.sortieBacs"/>
                  <img src="/static/img/rentree.svg" v-if="!intervention.sortieBacs"/>
                </div>
                <div class="details">
                  <span class="kind">{{(intervention.sortieBacs) ? 'Sortie' : 'Rentrée'}}</span>
                  <div class="hours" v-if="intervention.sortieBacs">
                    {{ intervention.adresse.heureDebutSortie }} -- {{ intervention.adresse.heureFinSortie }}
                  </div>
                  <div class="hours" v-if="!intervention.sortieBacs">
                    {{ intervention.adresse.heureDebutRentree }} -- {{ intervention.adresse.heureFinRentree }}
                  </div>
                </div>
              </div>
            </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="mode === 'edit'">
        <div class="row">
          <div class="col-sm-1">
            <div class="index-item">
              <span class="title-item">N°</span>
              <span class="text-item text-item--sm">{{intervention.order + 1}}</span>
            </div>
          </div>
          <div class="col-sm-5 left-separator right-separator">
            <div class="item-group">
              <span class="title-item">Adresse</span>
              <span
                class="text-item text-item--sm">{{intervention.adresse.numero}} {{intervention.adresse.voie}} {{intervention.adresse.ville}}</span>
            </div>
            <div class="item-group">
              <span class="title-item">Adresse de présentation</span>
              <div class="text-item text-item--sm input-adresse">
                <input type="text"
                       placeholder="Numéro"
                       size=4
                v-model="intervention.adresse.presentationNumero"/>
                <input type="text"
                       placeholder="Voie"
                       v-model="intervention.adresse.presentationVoie"/>
                <input type="text"
                       placeholder="Ville"
                       v-model="intervention.adresse.presentationVille"/>
              </div>
            </div>
            <div class="item-group">
              <span class="title-item">Heure d'ouverture des portes</span>
              <div class="text-item text-item--sm">
                <select v-model="intervention.adresse.heureOuverturePortes">
                  <option></option>
                  <option v-for="h in horairesPossibles" :value="h">{{h}}</option>
                </select>
              </div>
            </div>
            <div class="item-group">
              <span class="title-item">Points noirs</span>
              <div class="text-item text-item--sm">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="intervention.adresse.presenceMarches">
                    Présence de marches
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="intervention.adresse.plusTroisPortes">
                    Plus de 3 portes
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="intervention.adresse.pentu">
                    Pente à 30%
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="intervention.adresse.grandeDistance">
                    Plus de 50m
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="item-group">
              <span class="title-item">Bacs</span>
              <span class="text-item text-item--sm">
              <div class="input-bacs">
                <div class="imgAndType">
                  <img src="/static/img/poubelle-grise.svg"/> OM
                </div>
                <input type="number" min="0" v-model="intervention.adresse.bacsOm"/>
              </div>
              <div class="input-bacs">
                <div class="imgAndType">
                  <img src="/static/img/poubelle-jaune.svg"/> CS
                </div>
                <input type="number" min="0" v-model="intervention.adresse.bacsCs"/>
              </div>
            </span>
            </div>
            <div class="item-group">
              <span class="title-item">Commentaire</span>
              <textarea class="input-comment form-control" v-model="intervention.adresse.commentaire"></textarea>
            </div>
          </div>
          <div class="col-sm-3 left-separator">
            <div class="item-group">
              <span class="title-item">Status</span>
              <div class="sortie_rentree_hours sortie">
                <div class="icon sortie">
                  <img src="/static/img/sortie.svg"/>
                </div>
                <div class="details">
                  <span class="kind"><input type="radio" value="sortie" name="sortie_ou_rentree"
                                            v-model="sortieDesBacsRadioValue"/> Sortie</span>
                  <div class="hours">
                    <select v-model="intervention.adresse.heureDebutSortie">
                      <option></option>
                      <option v-for="h in horairesPossibles" :value="h">{{h}}</option>
                    </select>
                    --
                    <select v-model="intervention.adresse.heureFinSortie">
                      <option></option>
                      <option v-for="h in horairesPossibles" :value="h">{{h}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="sortie_rentree_hours">
                <div class="icon rentree">
                  <img src="/static/img/rentree.svg"/>
                </div>
                <div class="details">
                  <span class="kind"><input type="radio" value="rentree" name="sortie_ou_rentree"
                                            v-model="sortieDesBacsRadioValue"/> Rentrée</span>
                  <div class="hours">
                    <select v-model="intervention.adresse.heureDebutRentree">
                      <option></option>
                      <option v-for="h in horairesPossibles" :value="h">{{h}}</option>
                    </select>
                    --
                    <select v-model="intervention.adresse.heureFinRentree">
                      <option></option>
                      <option v-for="h in horairesPossibles" :value="h">{{h}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="mode === 'delete'" class="delete">
        <div>Êtes-vous sûr de bien vouloir supprimer l'intervention ?</div>
        <strong>{{intervention.adresse.numero}} {{intervention.adresse.voie}} {{intervention.adresse.ville}}</strong>
      </div>

      <div class="buttons" v-if="mode === 'show' && !canOnlyExitModal">
        <div class="btn btn-default" v-on:click="toggleDelete()">Supprimer</div>
        <div class="btn btn-primary" v-on:click="toggleEdit()">Modifier</div>
      </div>

      <div class="buttons" v-if="mode === 'edit' && !canOnlyExitModal">
        <div class="btn btn-default" v-on:click="toggleEdit()">Annuler</div>
        <div class="btn btn-primary" v-on:click="doEdit()">Valider</div>
      </div>

      <div class="buttons" v-if="mode === 'delete' && !canOnlyExitModal">
        <div class="btn btn-default" v-on:click="toggleDelete()">Annuler2</div>
        <div class="btn btn-primary" v-on:click="doDelete()">Supprimer</div>
      </div>

      <div class="loading-overlay" v-if="loading">
        Chargement ...
      </div>

    </div>
  </modal>
</template>

<script>
  import _ from 'lodash'
  import horairesPossibles from '../../../utils/horairesPossibles'
  import Modal from '../../modals/ModalBasic'

  export default {
    data () {
      return {
        mode: 'show',
        horairesPossibles,
        sortieDesBacsRadioValue: this.intervention.sortieBacs ? 'sortie' : 'rentree',
      }
    },
    props: [
      'hideDispatchAction',
      'intervention',
      'ronde',
    ],
    components: {
      Modal,
    },
    computed: {
      loading: function () {
        return this.$store.state.rondes.interventionDetailModal.loading
      },
      message: function () {
        return this.$store.state.rondes.interventionDetailModal.message
      },
      canOnlyExitModal: function () {
        return this.$store.state.rondes.interventionDetailModal.canOnlyExitModal
      },
    },
    methods: {
      cancel: function () {
        this.$store.dispatch(this.hideDispatchAction)
      },
      toggleDelete () {
        this.mode = (this.mode === 'delete') ? 'show' : 'delete'
      },
      toggleEdit () {
        this.mode = (this.mode === 'edit') ? 'show' : 'edit'
        this.intervention = this.$store.state.ronde.intervention
      },
      doEdit () {
        console.log("Adresse" , this.intervention.adresse)
        console.log("SortieBac" , this.sortieDesBacsRadioValue)
        this.$store.dispatch('updateInterventionAndAdresseV2', {
          intervention: _.cloneDeep(this.intervention),
          sortieDesBacs: this.sortieDesBacsRadioValue === 'sortie'
        })
      },
      doDelete () {
        this.$store.dispatch('removeInterventionV2', {
          intervention: _.cloneDeep(this.intervention),
          ronde: _.cloneDeep(this.ronde.data),
        })
      },
    },
  }
</script>

<style lang="scss">
  @import "../../../scss/variables";

  .ronde-details {

    min-width: 840px;

    .row {
      display: flex;
      height: auto;
      align-items: flex-start;
      margin-bottom: 0.5rem;
      margin-left: 0;
      margin-right: 0;
      overflow-x: hidden;

      .item-group {
        margin-bottom: 1rem;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          margin: 0;
          padding: 0;
        }
      }
    }

    .delete {
      text-align: center;
      padding: 5rem;
    }

  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba($suez-blue, 0.8);
    color: white;
    font-size: 2em;
    z-index: 9999999;
  }

  .sortie_rentree_hours {
    background-color: $suez-grey;
    height: 60px;
    margin-bottom: 5px;
    min-width: 200px;
    .icon {
      background-color: $rentree;
      float: left;
      height: 60px;
      line-height: 55px;
      padding: 0 5px;
      margin-right: 5px;
    }
    .details {
      padding: 5px;
    }
    &.sortie {
      .icon {
        background-color: $sortie;
      }
    }
  }

  .input-bacs {
    .imgAndType {
      width: 50px;
      display: inline-block;
      text-align: right;
      margin-top: 5px;
    }
    input {
      display: inline-block;
      width: 50px;
    }
  }

  .input-adresse {
    input {
      margin-bottom: 5px;
    }
  }

  .input-comment {
    max-width: 100%;
    max-height: 50vh;
  }
</style>




// WEBPACK FOOTER //
// RondeInterventionDetailsModal.vue?6945106f